/**
 * Интерфейс объекта сообщения чата
 */
class ChatMessage {
  /**
   * @param id {Number?} - ID сообщения
   * @param text {string} - Текст сообщения
   * @param roomId {string} - ID комнаты чата
   * @param parentOrderId {string?} - ID родительского заказа
   * @param type {Number} - ChatModel.ChatType
   * @param senderId {Number?} - ID отправителя
   * @param recipientId {Number?} - ID получателя
   * @param hash {string} - Хеш собщения
   * @param state {Number} - ID статуса сообщения ChatModel.MessageState
   * @param date {Number?} - Timestamp отправки сообщения
   * @param words {string[]?} - Массив стоп слов для проверки. Если не передан - проверка не производится.
   * @param isOk {Boolean} - False если сообщение содержит стоп-слова.
   */
  constructor({
    id,
    text,
    roomId,
    parentOrderId,
    type,
    senderId,
    recipientId,
    hash,
    state,
    date,
    isOk,
  }) {
    this.id = id;
    this.text = text;
    this.roomId = roomId;
    this.type = type;
    this.senderId = senderId;
    this.recipientId = recipientId;
    this.hash = hash || `${Date.now()}-${senderId}`;
    this.state = state;
    this.date = date;
    this.isOk = isOk === false ? isOk : true;
    this.parentOrderId = parentOrderId;
  }
}

export default ChatMessage;
